import { useState, useEffect } from "react";
import { useTenant } from "../../../hooks/useTenant";
import ActivityService from "../../../services/activity_service";

export const useEvaluationSystem = () => {
    const { idTenant, tenantLoading } = useTenant();
    
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openActivityId, setOpenActivityId] = useState(null);

    useEffect(() => {
        if (!tenantLoading && idTenant) {
            setLoading(true);
            ActivityService.getActivities(idTenant)
                .then(data => {
                    const evalActivities = data
                        .filter(a => a.evaluationSystem === true)
                        .sort((a, b) => (a.order || 0) - (b.order || 0));
                    setActivities(evalActivities);
                })
                .catch(err => console.error("Erro ao buscar atividades", err))
                .finally(() => setLoading(false));
                
            window.scrollTo(0, 0);
        }
    }, [idTenant, tenantLoading]);

    const toggleAccordion = (id) => {
        setOpenActivityId(prev => (prev === id ? null : id));
    };

    return {
        activities,
        loading,
        openActivityId,
        idTenant,
        tenantLoading,
        actions: {
            toggleAccordion
        }
    };
};
